import antdEn from 'antd/lib/locale-provider/en_US'
import anydHe from 'antd/lib/locale-provider/he_IL'
import antdRu from 'antd/lib/locale-provider/ru_RU'
import en from './en.json'
import he from './he.json'
import ru from './ru.json'

const antdLocales = {
  en: antdEn,
  he: anydHe,
  ru: antdRu,
}

export const localeNames = () => {
  return {
    en: 'ENGLISH',
    he: 'עברית',
    ru: 'РУССКИЙ',
  }
}

export const currentLocale = () => {
  switch (navigator.language) {
    case 'he-il':
      return 'he'
    case 'he-IL':
      return 'he'
    case 'he':
      return 'he'
    case 'ru-RU':
      return 'ru'
    case 'ru-ru':
      return 'ru'
    case 'ru':
      return 'ru'
    default:
      return 'en'
  }
}

export const isRtl = () => {
  return [
    'he',
    'he-IL',
  ].includes(currentLocale())
}

export const defaultLocale = () => {
  return en
}

export interface Locales {
    en: any,
    he: any,
    ru: any,
    [key: string]: any
}

export interface AllLocalesData {
    local: Locales,
    antd: Locales
}

export const locales: AllLocalesData = {
  local: { en, he, ru },
  antd: antdLocales,
}
